import { ColumnsType } from 'antd/es/table';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import { DataView } from 'src/components/DataView/DataView';
import { Table } from 'src/components/Table/Table';
import { DeclineInfoDto } from 'src/generated-api-client';

type LoanApplicationDeclineReasonsTableProps = {
    declineInfo: DeclineInfoDto[];
};

export const LoanApplicationDeclineReasonsTable = observer(
    ({ declineInfo }: LoanApplicationDeclineReasonsTableProps) => {
        return (
            <Table
                columns={columns}
                dataSource={declineInfo}
                rowKey="declinedAt"
                pagination={false}
            />
        );
    },
);

const columns: ColumnsType<DeclineInfoDto> = [
    {
        title: <Trans i18nKey="LoanApplication.DeclineReasons.Partner" />,
        dataIndex: 'declineBy',
        key: 'declineBy',
        render: (value) => {
            return <DataView value={value} />;
        },
    },
    {
        title: <Trans i18nKey="LoanApplication.DeclineReasons.DeclinedAt" />,
        dataIndex: 'declinedAt',
        key: 'declinedAt',
        render: (value) => {
            return <DataView value={value} formatValue="dateTimeSeconds" />;
        },
    },
    {
        title: <Trans i18nKey="LoanApplication.DeclineReasons.DeclineReason" />,
        dataIndex: 'declineReason',
        key: 'declineReason',
        render: (value) => {
            return <DataView value={value} />;
        },
    },
];
